module.exports = __webpack_public_path__ + "img/IMG-20181104-WA0016.211d0332.jpg";